import React, { Component, Fragment } from 'react'
// import { APIProvider, Map } from '@vis.gl/react-google-maps';
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { config } from '../config.js'
import {
  Button,
  Box,
  Divider,
  Icon,
  Grid,
  Paper,
  Typography,
  CircularProgress,
  CardMedia,
  TextareaAutosize,
} from '@material-ui/core'
import {
  TimelineSeparator,
  TimelineDot,
} from '@material-ui/lab'
import { withStyles } from '@material-ui/core/styles'
import withWidth, { isWidthUp, isWidthDown } from '@material-ui/core/withWidth'
import { startCase } from 'lodash'
import ReactPixel from 'react-facebook-pixel'
import AppTopBar from '../components/AppTopBar.js'
import SearchPanel from '../components/SearchPanel.js'
import Itinerary from '../components/itinerary/Itinerary.js'
import TripItinerary from '../components/trip/TripItinerary.js'
import TravelersFilter from '../components/filters/TravelersFilter.js'
import DatesFilter from '../components/filters/DatesFilter'
import PlaceField from '../components/forms/PlaceField.js'
import Cookies from 'universal-cookie'
import AssistantInput from '../components/AssistantInput';
import ErrorBoundary from '../components/ErrorBoundary';

const cookies = new Cookies();
const GOOGLE_MAPS_API_KEY = config.ui.GOOGLE_MAPS_API_KEY

class Assistant extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openedSigninDialog: false,
      openedSigninDialogType: 'signup',
      showHeader: true,

      travel: {
        travelers: {
          adults: 1,
          children: 0,
          infants: 0,
        },
        from: [],
        dates: {
          start_date: null,
          end_date: null,
          dates_type: null,
          nights: null,
        },
        description: '',
      },
      tripId: null,

      recommendations: {}, // Add this line to initialize recommendations
      isLoading: false,
      error: null,
      itinerary: [],
      isRefreshing: false,
      abortController: null,
      streamedResponse: '',
      responseBuffer: '',
      lastChunkTime: Date.now(),
      chunkQueue: [],
      isProcessingQueue: false
    }

    this.responseEndRef = React.createRef();
    this.CHUNK_INTERVAL = 50; // Milliseconds between chunk processing
    this.processingTimeout = null;
  }

  componentDidMount() {
    window.gtag('event', 'assistant');
    ReactPixel.pageView()
  }

  componentWillUnmount() {
    this.cleanup();
    if (this.typewriterTimeout) {
      clearTimeout(this.typewriterTimeout);
    }
  }

  cleanup = () => {
    if (this.state.abortController) {
      this.state.abortController.abort();
    }
  }

  isSize = (size) => {
    return isWidthDown(size, this.props.width)
  }

  handleChange = (event, index = false) => {
    if (index !== false) {
      let state = this.state[event.target.name]
      state[index] = merge(event.target.value, {id: state[index].id})
      this.setState({[event.target.name]: state});
    } else {
      this.setState({[event.target.name]: event.target.value});
    }
  }

  handleDescriptionChange = (event) => {
    this.setState({
      travel: {
        ...this.state.travel,
        description: event.target.value,
      },
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ isLoading: true, error: null, streamedResponse: '' });
    this.cleanup();

    const abortController = new AbortController();
    this.setState({ abortController });

    try {
      const response = await fetch(config.api.TRAVEL_URL + '/ai/assistant/recommendations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/event-stream',
        },
        body: JSON.stringify({
          travel: this.state.travel,
          trip_id: this.state.tripId,
        }),
        signal: abortController.signal
      });

      await this.processStream(response);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Connection error:', error);
      this.setState({
        error: error.message || 'Could not connect to server.',
        isLoading: false
      });
    }
  };

  async processStream(response) {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    try {
      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          if (buffer.trim()) {
            await this.enqueueChunk(buffer.trim());
          }
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const messages = buffer.split(/\n\n/);
        buffer = messages.pop() || '';

        for (const message of messages) {
          await this.enqueueChunk(message.trim());
        }
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      throw error;
    } finally {
      await this.processQueuedChunks();
      this.setState({ isLoading: false });
      reader.releaseLock();
    }
  }

  async enqueueChunk(chunk) {
    if (!chunk.startsWith('data: ')) return;

    const data = chunk.slice(5);
    if (data === '[DONE]') return;

    try {
      const parsed = JSON.parse(data);

      if (parsed.event === 'trip_created') {
        this.setState({ tripId: parsed.trip_id });
        return;
      }

      if (parsed.choices?.[0]?.delta?.content) {
        const content = parsed.choices[0].delta.content;
        this.setState(prevState => ({
          chunkQueue: [...prevState.chunkQueue, content]
        }), () => {
          if (!this.state.isProcessingQueue) {
            this.processQueuedChunks();
          }
        });
      }
    } catch (err) {
      console.error('Error parsing chunk:', err);
    }
  }

  async processQueuedChunks() {
    if (this.state.isProcessingQueue || this.state.chunkQueue.length === 0) return;

    this.setState({ isProcessingQueue: true });

    while (this.state.chunkQueue.length > 0) {
      const chunks = this.state.chunkQueue.splice(0, 3); // Process up to 3 chunks at a time
      const content = chunks.join('');

      await new Promise(resolve => {
        this.setState(prevState => ({
          streamedResponse: prevState.streamedResponse + content,
          chunkQueue: prevState.chunkQueue
        }), resolve);
      });

      // Add a small delay between chunk processing for smooth rendering
      await new Promise(resolve => setTimeout(resolve, this.CHUNK_INTERVAL));
    }

    this.setState({ isProcessingQueue: false });
  }

  fetchItinerary = async (tripId) => {
    try {
      const response = await fetch(`${config.api.TRAVEL_URL}/trips/${tripId}`, {
        headers: {
          'Authorization': cookies.get('jwt') ? `Bearer ${cookies.get('jwt')}` : undefined,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      this.setState({
        itinerary: data.itinerary || [],
        isRefreshing: !data.planned,
        isLoading: false
      });

      // Continue polling if the itinerary is still being generated
      if (!data.planned) {
        setTimeout(() => this.fetchItinerary(tripId), 5000);
      }
    } catch (error) {
      console.error("Error fetching itinerary:", error);
      this.setState({
        error: error.message || 'Failed to fetch itinerary.',
        isLoading: false
      });
    }
  };

  render() {
    const { classes, user } = this.props;
    const { travelers, from, description, dates } = this.state.travel;
    const { suggestions, isLoading, error, tripId, itinerary } = this.state;

    return (
      <ErrorBoundary>
        <Fragment>
        <Helmet>
          <title>{`Assistant`}</title>
          <link rel="canonical" href={`https://www${config.api.DOMAIN}/assistant`} />
        </Helmet>
        <AppTopBar
          hideMenu={false}
          hideBottomMenu={true}
          hideCurrency={true}
          showBackButton={false}
          backButtonPath={`/`}
          onLocationChanged={this.props.onLocationChanged}
          onLocationCleared={this.props.onLocationCleared}
          onCurrencyChange={this.handleReloadResults}
          onChange={this.props.onFilterChange}
          onSignin={this.props.onSignin}
          user={this.props.user}
          address={startCase(this.props.address)}
          tabSelected={this.props.tabSelected || 'assistant'}
          openedSigninDialog={this.state.signinDialogOpened}
          signinDialogType={this.state.openedSigninDialogType !== null && this.state.openedSigninDialogType}
        />

        <Grid container spacing={2} className={classes.grid} justify="center">

          <Grid item xs={12} md={7} className={classes.searchContainer}>
            <Grid container className={classes.searchWrapper}>
              <Grid item xs={6} md={6} className={classes.fromContainer}>
              <PlaceField
                name="from"
                label="Where from? *"
                autofocus={true}
                placeholder={from && from.length > 0 ? "Where from?" : "Enter location"}
                limitTags={3}
                single={false}
                standalone={true}
                defaultValues={from}
                onChange={(event) => this.handleChange(event)}
                classes={{iconLabel: classes.iconLabel}}
              />
              </Grid>
              <Grid item xs={3} md={3} className={classes.travelersContainer}>
                  <DatesFilter
                    name="dates"
                    dates_type = {dates && dates.dates_type}
                    start_date = {dates && dates.start_date}
                    end_date = {dates && dates.end_date}
                    nights={dates && dates.nights} d
                    onChange={this.handleChange}>
                  </DatesFilter>
              </Grid>
              <Grid item xs={3} md={3} className={classes.travelersContainer}>
              <TravelersFilter
                name="travelers"
                adults={travelers && travelers.adults}
                children={travelers && travelers.children}
                infants={travelers && travelers.infants}
                onChange={(event) => this.handleChange(event)}
                classes={{iconLabel: classes.iconLabel}}
              />
              </Grid>
            </Grid>

            <Box className={classes.itineraryRail}>
              <div className={classes.suggestions}>
                {error && (
                  <Typography color="error" variant="body2" className={classes.error}>
                    {error}
                  </Typography>
                )}

                {this.state.processingStatus && (
                  <Typography variant="body2" className={classes.processingStatus}>
                    {this.state.processingStatus}
                    <CircularProgress size={16} className={classes.progressIndicator} />
                  </Typography>
                )}

                {this.state.streamedResponse && (
                  <Paper elevation={0} className={classes.responseStream}>
                    <ReactMarkdown components={{
                      p: ({ children }) => (
                        <Typography
                          component="p"
                          variant="body1"
                          className={classes.streamingText}
                        >
                          {children}
                        </Typography>
                      )
                    }}>
                      {this.state.streamedResponse}
                    </ReactMarkdown>
                  </Paper>
                )}

                {this.state.recommendations && Object.entries(this.state.recommendations).length > 0 && (
                  Object.entries(this.state.recommendations).map(([category, items]) => (
                    <div key={category} className={classes.categorySection}>
                      <Typography variant="h6" className={classes.categoryTitle}>
                        {startCase(category)}
                      </Typography>
                      {items.map((item, index) => (
                        <Paper key={index} className={classes.suggestionItem}>
                          <Box display="flex" alignItems="center">
                            <Icon className={classes.suggestionIcon}>
                              {category === 'destination' ? 'place' :
                              category === 'hotel' ? 'hotel' :
                              category === 'travel' ? 'flight' : 'local_activity'}
                            </Icon>
                            <Box ml={2}>
                              <Typography variant="subtitle1">{item.title}</Typography>
                              <Typography variant="body2" color="textSecondary">
                                {item.description}
                              </Typography>
                            </Box>
                          </Box>
                        </Paper>
                      ))}
                    </div>
                  ))
                )}
              </div>

              {/* <Itinerary
                itinerary={this.state.itinerary}
                itineraryType="Trip"
                itineraryId={tripId}
                isRefreshing={this.state.isRefreshing}
                destination={null}
                user={user}
                itineraryLoaded={!this.state.isLoading}
                search_params={{
                  from: from,
                  description: description,
                  travelers: travelers,
                }}
                showAiAssistant={false}
              /> */}

              <Box className={classes.searchBoxSticky}>
                <TimelineSeparator>
                  <TimelineDot className={`${classes.itineraryIconRoot} ${classes.itineraryIconWhite}`}>
                    {isLoading && <CircularProgress style={{fontWeight: '500', margin: 'auto', position: 'absolute', height: 38, width: 38, top: -2, left: -2}}/>}
                    <Icon className={`${classes.icon} material-icons-outlined notranslate`}>
                    add_location_alt
                    </Icon>
                  </TimelineDot>
                </TimelineSeparator>
                <Grid item xs={12} className={`${classes.searchField}`}>
                  <div className={classes.destinationInputWrapper}>
                    <AssistantInput
                      onSubmit={this.handleSubmit}
                      isLoading={isLoading}
                      value={this.state.travel.description}
                      onChange={this.handleDescriptionChange}
                      classes={classes}
                    />
                  </div>
                </Grid>
              </Box>
            </Box>

          {/* <div className={classes.itineraryLabel}>Style</div>
          <div className={classes.itineraryLabel}>Theme</div> */}

          {/* Display TripItinerary Component */}

          </Grid>

          {/* <Grid item xs={12} md={5}>
          <Box className={classes.sidebarBox}>
            sidebar
          </Box>
          </Grid> */}
        </Grid>

        </Fragment>
      </ErrorBoundary>
    )
  }
}

const styles = theme => ({
  grid: {
    textAlign: 'left',
    maxWidth: 1142,
    margin: '50px auto 0px auto',
    width: 'calc(100% - 20px)',
    overflow: 'hidden',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: '0px 10px',
    },
  },
  topPanel: {
    padding: '0px 0px 0px 0px !important',
    margin: '0px auto',
    color: '#333',
    // textAlign: 'left',
    width: '100%',
    maxWidth: 1130,
    position: 'relative',
    boxShadow: 'none',
    paddingBottom: '96px',
    backgroundColor: 'transparent',
    // background: 'linear-gradient(180deg, rgb(26 83 53 / 9%) 0%, rgb(205 214 208 / 77%) 100%)',

    [theme.breakpoints.down('sm')]: {
      paddingBottom: 4,
    },
  },
  headerPaper: {
    padding: '0px 0px 150px 0px',
    margin: '-94px auto 0px auto',
    color: '#000',
    width: '100%',
    position: 'relative',
    boxShadow: 'none',
    backgroundColor: '#fafafa',
    display: 'block',
  },
  headerTitle: {
    maxWidth: 1119,
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: '40px',
    fontWeight: 800,
    textAlign: 'left',
    marginTop: '90px',
    padding: '80px 10px 0px 10px',


    [theme.breakpoints.down('xs')]: {
      padding: '90px 20px 0px 20px',
      fontSize: '30px',
      marginTop: '70px',
    },
  },
  headerMedia: {
    // maxWidth: 180,
    float: 'right',
    margin: '-10px 0px -27px 0px',
    width: '50vw',
    minWidth: '1000px',
    maxWidth: '1000px',
    position: 'absolute',
    left: '500px',
    top: '-112px',
    // top: '-152px',
    // top: '-62px',
    display: 'block',

    [theme.breakpoints.down('xs')]: {
      maxWidth: 150,
      margin: -10,
      display: 'none',
      minWidth: 600,
      left: '-70px',
      top: '-120px',
    },
  },
  subtitle: {
    fontWeight: 700,
    fontSize: '45% !important',
    // fontSize: '12px',
    color: '#828282',
    display: 'block',
    marginTop: 20,
    maxWidth: 490,
    lineHeight: 1.9,

    [theme.breakpoints.down('xs')]: {
      fontSize: '55% !important',
    },
  },
  searchField: {
    boxShadow: "0 5px 10px 0 rgb(0 0 0 / 5%)",
    border: '1px solid #ddd',
    borderRadius: 20,
    marginBottom: 10,
    backgroundColor: '#fff',
    zIndex: 1,
    position: 'relative',
  },
  searchBoxSticky: {
    position: 'sticky',
    bottom: 10,
    display: 'inline',
    zIndex: 3
  },
  icon: {
    marginRight: 5,
    fontSize: 15,
    fontWeight: 600,
    marginTop: -3,
    padding: '0px !important',
    verticalAlign: 'middle',
    color: '#02c39a',
  },
  iconLabel: {
    color: '#333',
    fontSize: 13,
    fontWeight: 700,
    marginLeft: 5,
  },
  itineraryRail: {
    textAlign: 'left',

    '&::before': {
      position: 'absolute',
      zIndex: 0,
      left: 39,
      width: 2,
      content: '""',
      top: 30,
      height: 'calc(100% - 90px)',
      background: '#f2f2f2',
    },
  },
  itineraryIconRoot: {
    float: 'left',
    zIndex: 3,
    position: 'absolute',
    left: 18,
    display: 'block',
    marginTop: 10,
    color: '#333',
    backgroundColor: '#c6e8c9',
    boxShadow: 'none',
    borderColor: "#eee",
  },
  itineraryIconWhite: {
    backgroundColor: '#fff',
  },
  icon: {
    verticalAlign: 'middle !important',
    padding: '4px !important',
    fontSize: 18,
  },
  textfieldArea: {
    width: 'calc(98% - 50px)',
    minWidth: 'calc(98% - 50px)',
    maxWidth: 'calc(98% - 50px)',
    textAlign: 'left',
    backgroundColor: '#fff',
    borderRadius: 10,
    margin: '2px 0px 0px 50px',
    fontSize: 15,
    fontWeight: 600,
    padding: '11px 5px',
    border: 'none',
    fontFamily: 'inherit',
    minHeight: 20,
    resize: 'none',

    '&:focus': {
      outline: 0,
    },
    '& fieldset': {
      borderColor: 'transparent !important',
      borderWidth: 1,
      borderRadius: 25,
      paddingLeft: 30,
    },
    '&:hover fieldset': {
      borderColor: 'transparent !important',
      borderWidth: 1,
      borderRadius: 25,
      paddingLeft: 30,
    },
    '&::placeholder': {
      color: '#999',
    },
  },
  searchContainer: {
    marginBottom: 10,
    width: '100%',
    position: 'absolute',
    maxWidth: 700,
  },
  searchWrapper: {
    marginBottom: 30,
    backgroundColor: '#fafafa',
    border: '1px solid #eee',
    borderRadius: 40,
    paddingLeft: 10,
    zIndex: 1,
    position: 'relative',
  },
  travelersContainer: {
    padding: '5px 5px 5px 5px',
    borderLeft: '1px solid #eee',
  },
  fromContainer: {
    paddingTop: 5,
  },
  itineraryLabel: {
    padding: '6px 5px 0px 50px',
  },
  destinationField: {
    boxShadow: "0 5px 10px 0 rgb(0 0 0 / 5%)",
    position: 'sticky',
  },
  destinationInputWrapper: {
    padding: '7px 5px 0px 5px',
    position: 'relative',
    display: 'flow-root',
  },
  sidebarBox: {
    textAlign: 'center',
    backgroundColor: '#fff',
    borderRadius: 15,
    minHeight: 200,
    boxShadow: "-2px 5px 10px 4px rgb(0 0 0 / 5%)",
  },
  suggestions: {
    marginTop: 20,
    marginBottom: 30,
    position: 'relative',
  },
  suggestionItem: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 10,
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
      cursor: 'pointer',
    }
  },
  suggestionIcon: {
    color: theme.palette.primary.main,
    fontSize: 24,
  },
  loadingBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  error: {
    marginBottom: theme.spacing(1),
  },
  secondRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  sendButton: {
    borderRadius: '50%',
    minWidth: '30px',
    width: '28px',
    height: '30px',
    margin: '5px 5px 10px 5px',
    float: 'right',
    color: '#fff',
  },
  responseStream: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    backgroundColor: '#f8f9fa',
    borderRadius: 15,
    border: '1px solid #e9ecef',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    '& p': {
      margin: '0.5em 0',
      lineHeight: '1.8',
      color: '#2c3e50',
      fontSize: '1rem',
      fontWeight: 400,
      transition: 'opacity 0.3s ease-out',
      opacity: 1
    },
    '& ul, & ol': {
      margin: '0.5em 0',
      paddingLeft: theme.spacing(2)
    },
    '& li': {
      margin: '0.3em 0'
    },
    '& code': {
      backgroundColor: '#f0f2f5',
      padding: '2px 4px',
      borderRadius: 4,
      fontSize: '0.9em'
    }
  },
  streamingText: {
    opacity: 1,
    marginBottom: theme.spacing(1),
    transform: 'translateY(0)',
    transition: 'opacity 0.3s ease-out, transform 0.3s ease-out'
  }
})

export default withRouter(withStyles(styles)(withWidth()(Assistant)))
